import {stringify, parse} from "query-string";

function makeQuery( query ) {

    var queryObject = {};

    if ( typeof(query) === "string" ) {
        queryObject = parse( query );
    } else {
        queryObject = query;
    }

    const {endpoint, ...queryParams} = queryObject;

    function getQueryString() {
        return stringify( queryParams );
    }

    function getHash() {
        const {resultFields, useSecureUrls, recolorable,  ...hashParams} = queryParams;
        return stringify( hashParams );
    }

    function getEndpoint() {
        return endpoint;
    }

    return Object.freeze({
        getQueryString,
        getHash,
        getEndpoint
    });

};

export default makeQuery;



// WEBPACK FOOTER //
// ./src/helper/Query.js